const { translateString } = window.BAO.Utils

class WishlistDelete extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleWishlistDetails = this.handleWishlistDetails.bind(this)
    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-delete-external-el="trigger"]',
    )

    if (!trigger) return

    const { wishlistId, wishlistName } = trigger.dataset

    this.els.submit.element.dataset.wishlistId = wishlistId

    this.els.text.element.innerHTML = translateString(
      this.translations?.delete?.text ?? '',
      {
        name: String(wishlistName ?? ''),
      },
    )

    window.drawers.activeDrawerKey = 'drawer-wishlist-delete'
  }

  handleSubmit () {
    const lid = this.els.submit.element.dataset.wishlistId

    window._swat.deleteList(
      lid,
      this.handleListDeleted.bind(this),
      this.wishlistError,
    )
  }

  handleListDeleted () {
    if (this.wishlistPage) {
      this.wishlistPage.updateHistory()
      this.wishlistPage.updateDocumentTitle()
    }

    window.location.reload()
  }

  handleWishlistDetails (wishlist) {
    this.els.text.element.innerHTML = translateString(
      this.translations?.delete?.text,
      {
        name: String(wishlist.list.lname),
      },
    )
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.error(`Wishlist error: ${errorMessage}`);
  }

  get translations () {
    return window.theme?.wishlist ?? {}
  }

  get wishlistPage () {
    return document.querySelector('wishlist-page')
  }
}

if (!customElements.get('wishlist-delete')) {
  customElements.define('wishlist-delete', WishlistDelete)
}
